import { Cart, ProductType, PrintType, PutRequestBody } from '@/types/types';
import { language, backendUrl } from '@/util/config';
import { FrameColor } from '@/types/print';
const cartBaseUrl = backendUrl

export default async function putItem(
  productId: string, 
  currency: string, 
  productType: ProductType, 
  printType: PrintType, 
  printProperties?: { frameColor: FrameColor },
  replaceId?: string
): Promise<Cart> {
  const putRequestBody: PutRequestBody = {
    product: {
      type: productType
    },
    print: {
      type: printType,
      printProperties
    },
    replaceId
  };
  const url = cartBaseUrl + `/cart/${productId}?returnCartLang=${language}&returnCartCurrency=${currency}`
  const putResponse = await fetch(
    url,
    {
      method: 'PUT',
      credentials: 'include',
      headers: {
        'Content-Type': 'application/json; charset=utf-8',
      },
      body: JSON.stringify(putRequestBody),
    }
  );
  if (putResponse.status > 400) {
    throw new Error('Could not add item: ' + (await putResponse.text()));
  }
  const response = await putResponse.json() as Cart
  return response
}